import React from "react";
import { Link } from "react-router-dom";
import "../App.css";
import { ReactComponent as LOGO } from "../assets/svg/logo.svg";

const Header = () => {
  return (
    <nav className="bg-white py-4 md:py-6 flex justify-between">
      <Link to="/">
        <LOGO className="h-8 w-8 fill-current text-sac ml-2 md:ml-8 lg:ml-24 hover:text-sac-darkest" />
      </Link>
      <div className="mx-2 md:mr-8 lg:mr-24 self-center">
        <Link
          to="/"
          className="mr-4 md:mr-6 font-semibold text-gray-600 hover:text-gray-800"
        >
          Home
        </Link>
        <Link
          to="/product"
          className="mr-4 md:mr-6 font-semibold text-gray-600 hover:text-gray-800"
        >
          Project
        </Link>
        <Link
          to="/Features"
          className="mr-4 font-semibold text-gray-600 hover:text-gray-800"
        >
          Features
        </Link>
        <Link
          to="/about"
          className="mr-2 font-semibold text-gray-600 hover:text-gray-800"
        >
          About us
        </Link>
      </div>
    </nav>
  );
};

export default Header;
